var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "vue-tel-input",
        "lib-tel-input",
        _vm.styleClasses,
        { disabled: _vm.disabled, _open: _vm.open },
      ],
    },
    [
      _vm.inputOptions.type === "checkbox"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone",
              },
            ],
            ref: "input",
            class: ["vti__input", _vm.inputOptions.styleClasses],
            attrs: {
              autocomplete: _vm.inputOptions.autocomplete,
              autofocus: _vm.inputOptions.autofocus,
              disabled: _vm.disabled,
              id: _vm.inputOptions.id,
              maxlength: _vm.inputOptions.maxlength,
              name: _vm.name,
              placeholder: _vm.parsedPlaceholder,
              readonly: _vm.inputOptions.readonly,
              required: _vm.required,
              tabindex: _vm.inputOptions.tabindex,
              "aria-describedby": _vm.inputOptions["aria-describedby"],
              type: "checkbox",
            },
            domProps: {
              checked: Array.isArray(_vm.phone)
                ? _vm._i(_vm.phone, null) > -1
                : _vm.phone,
            },
            on: {
              blur: _vm.onBlur,
              focus: _vm.onFocus,
              input: _vm.onInput,
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onEnter.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  ) {
                    return null
                  }
                  return _vm.onSpace.apply(null, arguments)
                },
              ],
              change: function ($event) {
                var $$a = _vm.phone,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.phone = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.phone = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.phone = $$c
                }
              },
            },
          })
        : _vm.inputOptions.type === "radio"
        ? _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone",
              },
            ],
            ref: "input",
            class: ["vti__input", _vm.inputOptions.styleClasses],
            attrs: {
              autocomplete: _vm.inputOptions.autocomplete,
              autofocus: _vm.inputOptions.autofocus,
              disabled: _vm.disabled,
              id: _vm.inputOptions.id,
              maxlength: _vm.inputOptions.maxlength,
              name: _vm.name,
              placeholder: _vm.parsedPlaceholder,
              readonly: _vm.inputOptions.readonly,
              required: _vm.required,
              tabindex: _vm.inputOptions.tabindex,
              "aria-describedby": _vm.inputOptions["aria-describedby"],
              type: "radio",
            },
            domProps: { checked: _vm._q(_vm.phone, null) },
            on: {
              blur: _vm.onBlur,
              focus: _vm.onFocus,
              input: _vm.onInput,
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onEnter.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  ) {
                    return null
                  }
                  return _vm.onSpace.apply(null, arguments)
                },
              ],
              change: function ($event) {
                _vm.phone = null
              },
            },
          })
        : _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.phone,
                expression: "phone",
              },
            ],
            ref: "input",
            class: ["vti__input", _vm.inputOptions.styleClasses],
            attrs: {
              autocomplete: _vm.inputOptions.autocomplete,
              autofocus: _vm.inputOptions.autofocus,
              disabled: _vm.disabled,
              id: _vm.inputOptions.id,
              maxlength: _vm.inputOptions.maxlength,
              name: _vm.name,
              placeholder: _vm.parsedPlaceholder,
              readonly: _vm.inputOptions.readonly,
              required: _vm.required,
              tabindex: _vm.inputOptions.tabindex,
              "aria-describedby": _vm.inputOptions["aria-describedby"],
              type: _vm.inputOptions.type,
            },
            domProps: { value: _vm.phone },
            on: {
              blur: _vm.onBlur,
              focus: _vm.onFocus,
              input: [
                function ($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.phone = $event.target.value
                },
                _vm.onInput,
              ],
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onEnter.apply(null, arguments)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "space", 32, $event.key, [
                      " ",
                      "Spacebar",
                    ])
                  ) {
                    return null
                  }
                  return _vm.onSpace.apply(null, arguments)
                },
              ],
            },
          }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "click-outside",
              rawName: "v-click-outside",
              value: _vm.clickedOutside,
              expression: "clickedOutside",
            },
          ],
          class: [
            "vti__dropdown",
            { open: _vm.open, disabled: _vm.dropdownOptions.disabled },
          ],
          attrs: {
            "aria-label": "Country Code Selector",
            "aria-haspopup": "listbox",
            "aria-expanded": _vm.open,
            role: "button",
            tabindex: _vm.dropdownOptions.tabindex,
          },
          on: {
            keydown: [
              _vm.keyboardNav,
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "space", 32, $event.key, [
                    " ",
                    "Spacebar",
                  ])
                ) {
                  return null
                }
                return _vm.toggleDropdown.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "esc", 27, $event.key, [
                    "Esc",
                    "Escape",
                  ])
                ) {
                  return null
                }
                return _vm.reset.apply(null, arguments)
              },
              function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "tab", 9, $event.key, "Tab")
                ) {
                  return null
                }
                return _vm.reset.apply(null, arguments)
              },
            ],
            click: _vm.toggleDropdown,
          },
        },
        [
          _c("div", { staticClass: "vti__selection" }, [
            _vm.dropdownOptions.showFlags
              ? _c("i", {
                  class: ["fi", "fi-" + _vm.activeCountryCode.toLowerCase()],
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.dropdownOptions.showDialCodeInSelection
              ? _c("div", { staticClass: "vti__country-code" }, [
                  _vm._v(
                    "\n                +" +
                      _vm._s(_vm.activeCountry && _vm.activeCountry.dialCode) +
                      "\n            "
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "arrow-icon" }, [
              _vm.open
                ? _c("i", { staticClass: "fas fa-angle-up" })
                : _c("i", { staticClass: "fas fa-angle-down" }),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _vm.open
        ? _c("div", { staticClass: "vti__dropdown-open" }, [
            _c("div", { staticClass: "lib-search-field" }, [
              _vm.dropdownOptions.showSearchBox
                ? _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.searchQuery,
                        expression: "searchQuery",
                      },
                    ],
                    staticClass: "vti__search_box",
                    attrs: {
                      type: "search",
                      "aria-label": "Search by country name or country code",
                      placeholder: "Search for Countries",
                    },
                    domProps: { value: _vm.searchQuery },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                      },
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.searchQuery = $event.target.value
                      },
                    },
                  })
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              {
                ref: "list",
                staticClass: "vti__dropdown-list",
                class: _vm.dropdownOpenDirection,
                attrs: { role: "listbox" },
              },
              _vm._l(_vm.sortedCountries, function (pb, index) {
                return _c(
                  "li",
                  {
                    key: pb.iso2 + (pb.preferred ? "-preferred" : ""),
                    class: [
                      "vti__dropdown-item",
                      _vm.getItemClass(index, pb.iso2),
                    ],
                    attrs: {
                      role: "option",
                      tabindex: "-1",
                      "aria-selected":
                        _vm.activeCountryCode === pb.iso2 && !pb.preferred,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.choose(pb)
                      },
                      mousemove: function ($event) {
                        _vm.selectedIndex = index
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "name-and-flag" }, [
                      _c("div", { staticClass: "country-flag" }, [
                        _vm.dropdownOptions.showFlags
                          ? _c("i", {
                              class: ["fi", "fi-" + pb.iso2.toLowerCase()],
                            })
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "country-name" }, [
                        _vm._v(_vm._s(pb.name)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm.dropdownOptions.showDialCodeInList
                      ? _c("div", { staticClass: "country-code" }, [
                          _vm._v(" +" + _vm._s(pb.dialCode) + " "),
                        ])
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("icon-right"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }